/* .footer {
    background-color: #1e1e1e;
    color: white;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    min-height: 7px;
    border-radius: 8px;
    padding: 20px 25px;
}

.footer .footer_copyright {
    font-size: small;
    text-align:end;
    color: #9c9c9c;
}

.footer .footer_copyright > a {
    text-decoration: none;
    color: var(--main-color);
} */

import {makeStyles} from '@material-ui/core';

const useStyles = makeStyles (theme => ({
  footer: {
    backgroundColor: '#2d3748',
    color: '#808d9f',
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    minHeight: 7,
    borderRadius: 8,
    padding: '20px 25px',
    [theme.breakpoints.down("xs")]: {
      textAlign:"center",
      justifyContent: "center",
      alignItems: "center"
    },
  },
  footerLeft: {},
  footerRight: {},
  footerName: {
    fontSize: "small",
  },
  footerCopyright: {
    fontSize: "small",
    textAlign:"end",
    color:"#808d9f"
  },
  a: {
    textDecoration: "none",
    color: "#bdbdbd"
  }
}));

export default useStyles;
